/**
 * The two attributes the queue cards find their own elements by.
 *
 * They are here rather than beside the hook that reads them because three other modules write
 * them — the row, the controls and the exit policy — and a hook importing a component's marker
 * while the component imports the hook is the cycle `import-x/no-cycle` catches.
 *
 * Attributes rather than refs, deliberately: what the card needs is "the row now standing at the
 * position the answered one held", which is a question about the DOM's current order and not about
 * any element React was holding a moment ago.
 */

/** Marks a drawn row, so the card can find the one that took an answered row's place. */
export const QUEUE_ROW_ATTRIBUTE = 'data-queue-row';

/** Marks one of the two responding controls inside a row, by the answer it records. */
export const QUEUE_CONTROL_ATTRIBUTE = 'data-queue-control';
